import React from 'react';
import { CareersSection } from '../components/CareersSection';

export const CareersPage: React.FC = () => {
  return (
    <div className="pt-20">
      <CareersSection />
    </div>
  );
};
